import { BrandfolderHexColors, FontIcon, FontIconProps, FontIcons } from '@brandfolder/react';

import classNames from 'classnames';
import { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import { PagesContext } from '@context/pages';
import { PublishContext } from '@context/publish';

interface PagesDragIconProps extends Omit<FontIconProps, 'icon'> {
  only?: boolean;
}

const UnstyledPagesDragIcon: FunctionComponent<PagesDragIconProps> = (props) => {
  const { only, ...otherProps } = props;

  const { editingSections, movingPage } = useContext(PagesContext);
  const { publishing } = useContext(PublishContext);

  if (only) return null;

  return (
    <FontIcon
      className={classNames({
        'pages-drag-icon': true,
        'pages-drag-icon--disabled': !!movingPage || editingSections.length > 0 || publishing,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
      icon={FontIcons.DragIndicator}
    />
  );
};

const StyledPagesDragIcon = styled(UnstyledPagesDragIcon)`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  width: 32px;

  &.pages-drag-icon--disabled {
    color: ${BrandfolderHexColors.GrayMedium};
    cursor: not-allowed;
  }
`;

export const PagesDragIcon: FunctionComponent<PagesDragIconProps> = (props) => {
  return <StyledPagesDragIcon {...props} />;
};
